<div [ngClass]="{ show: show }" class="filter-wrapper">
  <div class="wrapper">

    <div class="top">
      <p class="heading5 font-style-semi title">
        {{ "filters.filterResults" | translate }}
      </p>
      <div (click)="closeFilterBar()" class="close-button">
        <i class="ai ai-cancel"></i>
      </div>
    </div>

    <div class="separator-gray no-margin"></div>

    <div class="active-filters" *ngIf="this.show && searchResult.activeFilters?.length > 0">
      <app-active-filters [searchResult]="searchResult" [sidePanel]="true" (changed)="removeActiveFilter($event)" class="active-filters-desktop" #activeFilters></app-active-filters>
    </div>

    <div *ngFor="let filter of filters; trackBy: trackByIndex" #filterElems id="{{filter.code}}"
      class="filter-single"
      [ngClass]="{ collapsed: filter?.defaultExpanded === false, expanded: filter?.defaultExpanded === true }"
      [class.hidden]="filter && !filter.visible"
      [class.sup]="filter && filter.code == 'cena_za_metr_kwadratowy_promocja'">

      <p (click)="changeViewOfFilter(filter)" [innerHTML]="filter.name ? filter.name : ''" [ngClass]="{ 'gray-line': filter && filter.name == null }"></p>

      <app-select-filter
        *ngIf="filter.type === 'Select' || filter.type === 'Multiselect'"
        [filter]="filter"
        [id]="'filter_' + filter.code"
        (valueChanged)="changeSingleFilter($event)"
        (changeHeight)="changeHeight.emit()"
        (showTooltipPopup)="showTooltipPopup.emit($event)"
        [ngClass]="{ 'placeholder-elem': filter.code == undefined }">
      </app-select-filter>

      <app-interval-filter *ngIf="filter.isInterval" [filter]="filter" (valueChanged)="changeSingleFilter($event)"></app-interval-filter>
    </div>
  </div>
</div>
<div class="bottom" [ngClass]="{ show: show }">
  <div class="button-wrapper">
    <button class="button secondary-button" (click)="applyFilters()">
      {{ "filters.applyFilters" | translate }}
    </button>
    <div class="link" [ngClass]="{ 'disable-link': !activeFilters?.length }" (click)="clearFilters()">
      <i class="ai ai-cancel"></i>
      <a class="success-link">
        {{ "filters.cleanFilters" | translate }}
      </a>
    </div>
  </div>
</div>
